import { oktaAuth } from '../auth/okta';
import { errorSweetAlert, oopsSweetAlert } from "./SweetAlertMessages";
const serverBasePath    =   process.env.REACT_APP_SERVER_API_URL;

export const tooltipUploadImageFile = async(formData) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    const response  =  await fetch(serverBasePath+"/tooltip/upload/image",
    {     
        method: "POST",
        headers: {
            Authorization: 'Bearer ' + token,
        },
        body:formData
    });
    const result = await response.json();
    if(response.status !==  200){
        oopsSweetAlert(result);
        return;
    }
    return result?.data;
}

export const readSocketFile = async(formData) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
        const response  = await fetch(serverBasePath+"/remote/readSocketFile?fileName="+formData?.file_name,
        {     
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
        });
        const result = await response.json();
        if(response.status !==  200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch (e) {   
        errorSweetAlert(e);   
    }
}


export const updateSocketConnection = async(formData) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token'); 
    try {
        const response  = await fetch(serverBasePath+"/remote/updateClientDetails",
        {     
            method: "PUT",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        const result = await response.json();
        if(response.status !==  200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch (e) {   
        errorSweetAlert(e);   
    }
}

export const disconnectSocketConnection = async(formData) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
        const response  = await fetch(serverBasePath+"/remote/updateConnectionStatus",
        {     
            method: "PUT",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        const result = await response.json();
        if(response.status !==  200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch (e) {   
        errorSweetAlert(e);   
    }
}

export const deleteSocketTimeOutRequest = async(formData) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
        const response  = await fetch(serverBasePath+"/remote/deleteTimeOutConnection",
        {     
            method: "PUT",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });
        const result = await response.json();
        if(response.status !==  200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch (e) {   
        errorSweetAlert(e);   
    }
}


export const checkLiveConnectionExist = async(row_id,room_id) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
        const response  = await fetch(serverBasePath+"/remote/getLiveConnectionDetails?row_id="+row_id+"&room_id="+room_id,
        {     
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
        });
        const result = await response.json();
        if(response.status !==  200){
            oopsSweetAlert(result);
            return;
        }
        return result;
    } catch (e) {   
       errorSweetAlert(e); 
    }
}

export const userAndRolePermissions = async(permission) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    const response  = await fetch(serverBasePath+"/user/getUserAndRolePermissions?permission="+permission,
    {     
        method: "GET",
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
    });
    const result = await response.json();
    return result;
}